import { render, staticRenderFns } from "./CreateCompanyValuesModal.vue?vue&type=template&id=1aa2d8cd&scoped=true&"
import script from "./CreateCompanyValuesModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateCompanyValuesModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateCompanyValuesModal.vue?vue&type=style&index=0&id=1aa2d8cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2d8cd",
  null
  
)

export default component.exports